module.exports = __webpack_public_path__ + "static/img/helpCenter.34b0a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/helpCenter.jpg
// module id = It4M
// module chunks = 2